export function getRangiDeviceId() {
  const newKey = 'rangi_device_id';
  const oldKey = 'device_id';

  let id = localStorage.getItem(newKey);

  // Миграция со старого ключа, который уже использовался в Chats.js
  if (!id) {
    id = localStorage.getItem(oldKey);
  }

  if (!id) {
    if (window.crypto?.randomUUID) {
      id = window.crypto.randomUUID();
    } else {
      id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
  }

  localStorage.setItem(newKey, id);

  return id;
}